/* eslint-disable */ /* THIS FILE HAS BEEN GENERATED. DO NOT EDIT IT. */ import { jsx as _jsx } from "react/jsx-runtime";
import { createIcon } from '../utils';
// prettier-ignore
const ReorderIcon = createIcon({
    displayName: 'ReorderIcon',
    viewBox: '0 0 24 24',
    pathSmall: [
        /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            d: "M4 9.33h16V8H4v1.33Zm16 3.335H4v-1.33h16v1.33ZM20 16H4v-1.33h16V16Z",
            clipRule: "evenodd"
        })
    ],
    pathMedium: [
        /*#__PURE__*/ _jsx("path", {
            d: "M1 6h22v2H1V6Zm22 5H1v2h22v-2Zm0 5H1v2h22v-2Z"
        })
    ]
});
ReorderIcon.defaultProps = {
    fill: 'currentColor',
    boxSize: '24px',
    display: 'block',
    ['data-testid']: 'ReorderIcon'
};
export { ReorderIcon };

//# sourceMappingURL=reorder.js.map